import Updater from './Updater';

class Timer {
    static init(obj, timestamp) {
        var id = obj.parents('[data-bid]').attr('data-lot');

        this.timeouts = this.timeouts || [];

        if (this.timeouts[id]) {
            clearTimeout(this.timeouts[id])
            delete this.timeouts[id];
        }

        var rest = timestamp - Date.parse(new Date()) - window.timeDiff - window.timeShift;

        if (rest < 1000) {
            obj.text('00:00:00');
            return;
        }

        obj[0].didEnd = true;

        obj.text(Timer.parseTimestamp(rest));

        return this.timeouts[id] = setTimeout(Timer.init, 1000, obj, timestamp)
    }

    static parseTimestamp(timestamp) {
        var ms = timestamp % 1000;
        timestamp = (timestamp - ms) / 1000;
        var secs = timestamp % 60;
        timestamp = (timestamp - secs) / 60;
        var mins = timestamp % 60;
        var hrs = (timestamp - mins) / 60;

        return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins) + ':' + (secs < 10 ? '0' + secs : secs);
    }

    static getTimestamp(timestamp) {
        var parsed = /(\d{4})\-(\d{2})\-(\d{2})\s(\d{2}):(\d{2}):(\d{2})/gm.exec(timestamp);

        return Date.parse(new Date(
            parseInt(parsed[1]),
            parseInt(parsed[2]) - 1, // Месяц
            parseInt(parsed[3]),
            parseInt(parsed[4]),
            parseInt(parsed[5]),
            parseInt(parsed[6])
        ));
    }

    static update(s_time) {
        window.timeDiff = s_time - Date.parse(new Date());
    }
}

export default Timer;